// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import userProfile css modules
import userProfileStyles from '../userProfileModuleStyles.css';

function UserProfileListItem({ userProfile }) {
  return (
    <li>
      <Link to={`/user-profiles/${userProfile._id}`}> {userProfile.name}</Link>
    </li>
  )
}

UserProfileListItem.propTypes = {
  userProfile: PropTypes.object.isRequired
}

export default UserProfileListItem;



// WEBPACK FOOTER //
// modules/userProfile/components/UserProfileListItem.js.jsx